import { styled, Box } from "@mui/material";

export const GPTListContainer = styled(Box)({
    overflowY: "auto",
    height: "100%",
    backgroundColor: "#F7FCFE",
    color: "#146B6E",
    borderRadius: "8px",
    padding: "4px 8px 4px 4px",
    width: "100%",
});

export const GPTMessage = styled(Box)<{ expanded?: boolean }>(
    ({ expanded }) => ({
        fontSize: "14px",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        lineHeight: "20px",
        position: "relative",
        ...(expanded
            ? {}
            : {
                  WebkitLineClamp: 4,
                  lineClamp: 4,
              }),
    }),
);

export const GPTMessageHidden = styled(Box)<{ width?: string }>(
    ({ width }) => ({
        visibility: "hidden",
        fontSize: "14px",
        lineHeight: "20px",
        whiteSpace: "pre-wrap",
        overflow: "hidden",
        position: "absolute",
        width: width || "auto",
        top: 0,
        left: 0,
    }),
);

export const ExpandButton = styled(Box)({
    color: "var(--community-color-primary-text)",
    fontWeight: 500,
    cursor: "pointer",
    marginTop: "2px",
    fontSize: "14px",
});

export const Caret = styled(Box)({
    display: "inline-block",
    width: "2px",
    height: "1em",
    backgroundColor: "black",
    marginLeft: "2px",
    animation: "shimmer 1s infinite",

    "@keyframes shimmer": {
        "0%": {
            opacity: 1,
        },
        "50%": {
            opacity: 0.3,
        },
        "100%": {
            opacity: 1,
        },
    },
});
